var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGwDeviceSmile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 180,
    height: 157.409,
    viewBox: "0 0 180 157.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d5c76",
    stopOpacity: 0.698
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GatewaySmiling",
    transform: "translate(-6171 297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594",
    transform: "translate(6171 -297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_397",
    "data-name": "Rectangle 397",
    transform: "translate(0 37.895)",
    fill: "none",
    stroke: "#4c5b77",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 108.583,
    rx: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 178,
    height: 106.583,
    rx: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_398",
    "data-name": "Rectangle 398",
    transform: "translate(4.372 42.996)",
    stroke: "#4c5b77",
    strokeWidth: 2,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 171.255,
    height: 98.381,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 169.255,
    height: 96.381,
    rx: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_399",
    "data-name": "Rectangle 399",
    transform: "translate(129.717 12.389)",
    fill: "none",
    stroke: "#4c5b77",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.202,
    height: 26.964,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 8.202,
    height: 24.964,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_400",
    "data-name": "Rectangle 400",
    transform: "translate(129.717)",
    fill: "none",
    stroke: "#4c5b77",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.1,0h0a5.1,5.1,0,0,1,5.1,5.1v8.745a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5.1A5.1,5.1,0,0,1,5.1,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1,1h0A4.1,4.1,0,0,1,9.2,5.1v7.661a.084.084,0,0,1-.084.084H1.084A.084.084,0,0,1,1,12.762V5.1A4.1,4.1,0,0,1,5.1,1Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1351",
    "data-name": "Line 1351",
    x2: 8.745,
    transform: "translate(130.81 4.737)",
    fill: "none",
    stroke: "#4c5b77",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_401",
    "data-name": "Rectangle 401",
    transform: "translate(31.336 145.02)",
    fill: "none",
    stroke: "#4c5b77",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H118.057a0,0,0,0,1,0,0V7.389a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V0A0,0,0,0,1,0,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,1H116.057a1,1,0,0,1,1,1V7.389a4,4,0,0,1-4,4H5a4,4,0,0,1-4-4V2A1,1,0,0,1,2,1Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M0,0A30.391,30.391,0,0,1,8.976,21.486,30.4,30.4,0,0,1,.013,42.963",
    transform: "translate(6282.481 -204.748) rotate(90)",
    fill: "none",
    stroke: "#4c5b77",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGwDeviceSmile);
export default __webpack_public_path__ + "static/media/gw_device_smile.eb9f940b9c24d587e64b037f3cee9453.svg";
export { ForwardRef as ReactComponent };